import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import Divider from "@mui/material/Divider";
import PersonIcon from "@mui/icons-material/Person";
import BadgeIcon from "@mui/icons-material/Badge";
import { useLocation, useNavigate } from "react-router-dom";

import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";
import PageLayout from "examples/LayoutContainers/PageLayout";
import Footer from "layouts/authentication/components/Footer";

import bannerLogo from "assets/FirstPageLogo.jpg";
import FirstpageLogo from "assets/images/Loginimage.png";
import FirstpageLogo1 from "assets/images/LoginPageImage.jpg";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import safeToast from "utils/safeToast";
import { API_ENDPOINTS } from "config/api";
import { decryptText, encryptText } from "config/encryption";
import axiosInstance from "API/axiosInstance";

function CheckingAuth() {
  const [rollNo, setRollNo] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [loginMode, setLoginMode] = useState("roll");
  const [userType, setUserType] = useState("student");

  const location = useLocation();
  const navigate = useNavigate();

  const decryptResponse = (encryptedText) => {
    try {
      return decryptText(encryptedText);
    } catch (err) {
      console.error("Decryption error:", err);
      return null;
    }
  };

  useEffect(() => {
    const msg = location.state?.message;
    if (msg) setError(msg);

    const sessionData = localStorage.getItem("userSession");
    const sessionLoggedUserDetail = localStorage.getItem("UserLogDetails");

    if (sessionData && sessionLoggedUserDetail) {
      const decryptedUserDetails = decryptText(sessionData);
      const parsedUserDetails = JSON.parse(decryptedUserDetails);
      const usn = parsedUserDetails?.usn || "";

      const decryptedLoggedUserDetails = decryptText(sessionLoggedUserDetail);
      const parsedLoggedUserDetails = JSON.parse(decryptedLoggedUserDetails);
      const lus = parsedLoggedUserDetails?.UserName || "";

      if (usn === lus) {
        safeToast.warn("Already found Login. Redirecting to Myprofile...");
        setTimeout(() => {
          navigate("/MyDetails");
        }, 1000);
      }
    }
  }, [location.state]);

  const handleCheck = async () => {
    setError("");
    setMessage("");
    setLoading(true);

    const input = loginMode === "roll" ? rollNo.trim().toUpperCase() : mobileNo.trim();
    if (!input) {
      setError(`Please enter a valid ${loginMode === "roll" ? (userType === "student" ? "Roll Number" : "Login Code") : "Mobile Number"}.`);
      setLoading(false);
      return; 
    }

    // Show under development for Admin Mobile Number
    if (userType === "staff" && loginMode === "mobile") {
      setError("This feature is under development.");
      setLoading(false);
      return;
    }

    if (loginMode === "mobile" && input.length !== 10) {
      setError("Please enter a valid Mobile Number.");
      setLoading(false);
      return;
    }

    try {
      let encrypted, decrypted;

      if (userType === "staff" && loginMode === "roll") {
        // Admin login with Login Code
        const encryptedLoginCode = encryptText(input);
        const { data } = await axiosInstance.post(
          API_ENDPOINTS.AUTH.CHECK_STAFF_BY_LOGIN_CODE,
          { loginCode: encryptedLoginCode }
        );
        decrypted = decryptResponse(data);

        if (decrypted) {
          localStorage.removeItem("adminsessiondetails");
          localStorage.setItem("adminsessiondetails", data);
          setMessage("Admin found. Redirecting...");
          setTimeout(() => {
            navigate("/AdminLogin");
          }, 2000);
        } else {
          setError("Unable to decrypt admin response.");
        }
      } else {
        // Student or other login
        const { data: encrypted } = await axiosInstance.post(
          API_ENDPOINTS.AUTH.CHECK_USER,
          loginMode === "roll" ? { rollNum: input } : { mobile: input }
        );
        decrypted = decryptResponse(encrypted);

        if (decrypted) {
          localStorage.removeItem("userSession");
          localStorage.removeItem("UserLogDetails");
          localStorage.setItem("userSession", encrypted);
          setMessage("User found. Redirecting...");
          setTimeout(() => {
            navigate("/authentication/sign-in");
          }, 2000);
        } else {
          setError("Unable to decrypt response.");
        }
      }
    } catch (err) {
      console.error("CheckUser error:", err);
      setError("Verification failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setRollNo("");
    setMobileNo("");
    setMessage("");
    setError("");
  };

  return (
    <PageLayout>
      <MDBox
        display="flex"
        flexDirection="column"
        minHeight="100vh"
        sx={{
          background: (theme) => `linear-gradient(135deg, ${theme.palette.primary.light}15 0%, ${theme.palette.info.light}15 50%, ${theme.palette.secondary.light}15 100%)`,
          position: "relative",
          overflow: "hidden",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: (theme) => `radial-gradient(circle at 20% 50%, ${theme.palette.primary.light}20 0%, transparent 50%),
                                   radial-gradient(circle at 80% 80%, ${theme.palette.info.light}20 0%, transparent 50%)`,
            pointerEvents: "none",
          },
        }}
      >
        {/* Floating logo with glow and fade-in */}
        {/* <MDBox
          position="absolute"
          top={{ xs: 18, sm: 32 }}
          left="50%"
          sx={{
            display: { xs: "none", md: "block" }, // Hide on xs/sm, show on md+
            transform: "translateX(-50%)",
            zIndex: 10,
            animation: "fadeInLogo 1.2s",
            "@keyframes fadeInLogo": {
              from: { opacity: 0, transform: "translateX(-50%) scale(0.8)" },
              to: { opacity: 1, transform: "translateX(-50%) scale(1)" },
            },
          }}
        >
          <MDBox
            component="img"
            src={FirstpageLogo}
            alt="IMPRES Logo"
            sx={{
              width: { xs: 70, sm: 100 },
              height: { xs: 70, sm: 100 },
              borderRadius: "50%",
              boxShadow: "0 0 24px 4px #90caf9, 0 2px 12px 0 #fff",
              border: "4px solid #fff",
              background: "#fff",
              objectFit: "cover",
              transition: "box-shadow 0.3s",
            }}
          />
        </MDBox> */}

        <MDBox flexGrow={1} px={2} py={6} display="flex" alignItems="center" justifyContent="center" position="relative" zIndex={1}>
          <Grid container spacing={4} alignItems="center" justifyContent="center">
            <Grid item xs={12} md={6}>
              <MDBox
                sx={{
                  background: (theme) => theme.palette.background.paper,
                  borderRadius: 4,
                  boxShadow: (theme) => `0 8px 32px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,0.1)'}`,
                  p: { xs: 3, sm: 4, md: 5 },
                  mx: "auto",
                  maxWidth: 480,
                  minWidth: { xs: "unset", sm: 360 },
                  border: (theme) => `1px solid ${theme.palette.divider}`,
                  transition: "all 0.3s ease",
                  "&:hover": {
                    boxShadow: (theme) => `0 12px 40px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.4)' : 'rgba(0,0,0,0.15)'}`,
                  },
                }}
              >
                <MDBox
                  sx={{
                    textAlign: "center",
                    mb: 3,
                    pb: 2,
                    borderBottom: (theme) => `2px solid ${theme.palette.divider}`,
                  }}
                >
                  <MDTypography
                    variant="h4"
                    fontWeight="bold"
                    color="primary"
                    textAlign="center"
                    mb={1}
                    sx={{ 
                      letterSpacing: 0.5,
                      fontSize: { xs: 22, sm: 26 },
                      background: (theme) => `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.info.main})`,
                      backgroundClip: "text",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    Welcome to IMPRES Alumni Portal
                  </MDTypography>
                  <MDTypography
                    variant="body2"
                    color="text"
                    textAlign="center"
                    sx={{ 
                      opacity: 0.8,
                      fontSize: 14,
                      mt: 1,
                    }}
                  >
                    Please select your login type and verify your identity to continue
                  </MDTypography>
                </MDBox>

                <MDBox 
                  display="flex" 
                  justifyContent="center" 
                  mb={3} 
                  gap={1.5}
                  sx={{
                    background: (theme) => theme.palette.mode === 'dark' ? theme.palette.background.default : theme.palette.grey[50],
                    borderRadius: 2,
                    p: 1,
                  }}
                >
                  <MDButton
                    variant={userType === "student" ? "gradient" : "outlined"}
                    color={userType === "student" ? "primary" : "secondary"}
                    onClick={() => { setUserType("student"); setLoginMode("roll"); }}
                    startIcon={<PersonIcon />}
                    sx={{
                      flex: 1,
                      fontWeight: 600,
                      borderRadius: 2,
                      fontSize: 14,
                      py: 1.2,
                      textTransform: "none",
                      boxShadow: userType === "student" ? 3 : 0,
                      transition: "all 0.3s ease",
                    }}
                  >
                    Alumni
                  </MDButton>
                  <MDButton
                    variant={userType === "staff" ? "gradient" : "outlined"}
                    color={userType === "staff" ? "info" : "secondary"}
                    onClick={() => { setUserType("staff"); setLoginMode("roll"); }}
                    startIcon={<BadgeIcon />}
                    sx={{
                      flex: 1,
                      fontWeight: 600,
                      borderRadius: 2,
                      fontSize: 14,
                      py: 1.2,
                      textTransform: "none",
                      boxShadow: userType === "staff" ? 3 : 0,
                      transition: "all 0.3s ease",
                    }}
                  >
                    Admin
                  </MDButton>
                </MDBox>

                <MDBox mb={3}>
                  <MDTypography
                    variant="h6"
                    mb={2}
                    fontWeight="bold"
                    color="text"
                    textAlign="center"
                    sx={{ fontSize: 16 }}
                  >
                    {userType === "student" ? "Student Verification" : "Admin Verification"}
                  </MDTypography>

                  <MDBox 
                    display="flex" 
                    justifyContent="center" 
                    gap={1}
                    sx={{
                      background: (theme) => theme.palette.mode === 'dark' ? theme.palette.background.default : theme.palette.grey[50],
                      borderRadius: 2,
                      p: 0.5,
                    }}
                  >
                    <MDButton
                      variant={loginMode === "roll" ? "contained" : "text"}
                      color={userType === "student" ? "warning" : "info"}
                      onClick={() => setLoginMode("roll")}
                      sx={{
                        flex: 1,
                        borderRadius: 1.5,
                        fontWeight: 600,
                        fontSize: 13,
                        py: 1,
                        textTransform: "none",
                        boxShadow: loginMode === "roll" ? 2 : 0,
                        transition: "all 0.3s ease",
                      }}
                    >
                      {userType === "student" ? "Alunmi Code" : "Login Code"}
                    </MDButton>
                    <MDButton
                      variant={loginMode === "mobile" ? "contained" : "text"}
                      color={userType === "student" ? "warning" : "info"}
                      onClick={() => setLoginMode("mobile")}
                      disabled={userType === "staff"}
                      sx={{
                        flex: 1,
                        borderRadius: 1.5,
                        fontWeight: 600,
                        fontSize: 13,
                        py: 1,
                        textTransform: "none",
                        boxShadow: loginMode === "mobile" ? 2 : 0,
                        transition: "all 0.3s ease",
                      }}
                    >
                      Mobile Number
                    </MDButton>
                  </MDBox>
                </MDBox>

                <MDBox mb={2}>
                  <MDTypography 
                    variant="body2" 
                    color="text" 
                    mb={2} 
                    textAlign="center" 
                    sx={{ 
                      fontSize: 13,
                      opacity: 0.7,
                    }}
                  >
                    Enter your {loginMode === "roll"
                      ? (userType === "student" ? "roll number" : "login code")
                      : "mobile number"} to continue
                  </MDTypography>

                  {loginMode === "roll" ? (
                    <MDInput
                      fullWidth
                      label={userType === "student" ? "Alunmi Code" : "Login Code"}
                      placeholder={userType === "student" ? "e.g., ERPS001" : "e.g., ADMIN001"}
                      value={rollNo}
                      onChange={(e) => setRollNo(e.target.value.toUpperCase())}
                      sx={{
                        mb: 1,
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                          background: (theme) => theme.palette.mode === 'dark' ? theme.palette.background.default : theme.palette.grey[50],
                          "&:hover": {
                            background: (theme) => theme.palette.mode === 'dark' ? theme.palette.background.default : theme.palette.grey[100],
                          },
                          "&.Mui-focused": {
                            background: (theme) => theme.palette.background.paper,
                            boxShadow: (theme) => `0 0 0 2px ${theme.palette.primary.main}20`,
                          },
                        },
                      }}
                    />
                  ) : (
                    <MDInput
                      fullWidth
                      label="Mobile Number"
                      placeholder="e.g., 9876543210"
                      value={mobileNo}
                      onChange={(e) => setMobileNo(e.target.value)}
                      sx={{
                        mb: 1,
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                          background: (theme) => theme.palette.mode === 'dark' ? theme.palette.background.default : theme.palette.grey[50],
                          "&:hover": {
                            background: (theme) => theme.palette.mode === 'dark' ? theme.palette.background.default : theme.palette.grey[100],
                          },
                          "&.Mui-focused": {
                            background: (theme) => theme.palette.background.paper,
                            boxShadow: (theme) => `0 0 0 2px ${theme.palette.primary.main}20`,
                          },
                        },
                      }}
                      type="tel"
                    />
                  )}
                </MDBox>

                {error && (
                  <MDAlert 
                    color="error" 
                    dismissible 
                    sx={{ 
                      mb: 2, 
                      borderRadius: 2,
                      "& .MuiAlert-icon": {
                        color: "error.main",
                      },
                    }}
                  >
                    {error}
                  </MDAlert>
                )}
                {message && (
                  <MDAlert 
                    color="success" 
                    dismissible 
                    sx={{ 
                      mb: 2,
                      borderRadius: 2,
                      "& .MuiAlert-icon": {
                        color: "success.main",
                      },
                    }}
                  >
                    {message}
                  </MDAlert>
                )}
                {userType === "staff" && loginMode === "mobile" && (
                  <MDAlert 
                    color="warning" 
                    sx={{ 
                      mb: 2,
                      borderRadius: 2,
                      "& .MuiAlert-icon": {
                        color: "warning.main",
                      },
                    }}
                  >
                    This feature is under development.
                  </MDAlert>
                )}

                <Grid container spacing={2} mt={1}>
                  <Grid item xs={6}>
                    <MDButton
                      fullWidth
                      color="primary"
                      onClick={handleCheck}
                      disabled={loading || (userType === "staff" && loginMode === "mobile")}
                      variant="gradient"
                      sx={{
                        borderRadius: 2,
                        fontWeight: 600,
                        py: 1.5,
                        fontSize: 14,
                        textTransform: "none",
                        boxShadow: 3,
                        "&:hover": {
                          boxShadow: 4,
                        },
                        "&:disabled": {
                          opacity: 0.6,
                        },
                      }}
                    >
                      {loading ? <CircularProgress size={20} color="inherit" /> : "Verify"}
                    </MDButton>
                  </Grid>
                  <Grid item xs={6}>
                    <MDButton
                      fullWidth
                      color="secondary"
                      onClick={handleReset}
                      disabled={loading}
                      variant="outlined"
                      sx={{
                        borderRadius: 2,
                        fontWeight: 600,
                        py: 1.5,
                        fontSize: 14,
                        textTransform: "none",
                        borderWidth: 2,
                        "&:hover": {
                          borderWidth: 2,
                        },
                      }}
                    >
                      Reset
                    </MDButton>
                  </Grid>
                </Grid>
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} sx={{ display: { xs: "none", md: "flex" }, alignItems: "center" }}>
              <MDBox
                component="img"
                src={FirstpageLogo1}
                alt="Banner"
                width="100%"
                sx={{
                  borderRadius: 4,
                  objectFit: "cover",
                  boxShadow: (theme) => `0 12px 40px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.4)' : 'rgba(0,0,0,0.15)'}`,
                  border: (theme) => `3px solid ${theme.palette.background.paper}`,
                  maxHeight: 600,
                  background: (theme) => theme.palette.background.paper,
                  animation: "fadeInBanner 1s ease-in",
                  transition: "transform 0.3s ease",
                  "&:hover": {
                    transform: "scale(1.02)",
                  },
                  "@keyframes fadeInBanner": {
                    from: { opacity: 0, transform: "translateX(20px)" },
                    to: { opacity: 1, transform: "translateX(0)" },
                  },
                }}
              />
            </Grid>
          </Grid>
        </MDBox>
{/* 
        <MDTypography
          variant="caption"
          display="block"
          textAlign="center"
          mt={5}
          color="text"
          sx={{ opacity: 0.7, fontSize: 16, letterSpacing: 0.5 }}
        >
          “Success doesn’t come from what you do occasionally, it comes from what you do
          consistently.” 💡
        </MDTypography> */}
        <ToastContainer />
     
      </MDBox>
    </PageLayout>
  );
}

export default CheckingAuth;
